/** Where a pin sits, in degrees. */
export interface MapPin {
  latitude: number;
  longitude: number;
}

/** A place a search found: its name, full address, provider id and pin. */
export interface MapPlace extends MapPin {
  name: string;
  address: string;
  placeId?: string;
}

const NUMBER = String.raw`-?\d{1,3}(?:[.,]\d+)?`;
const PAIR = new RegExp(String.raw`^\s*(${NUMBER})\s*(?:[,;]\s*|\s+)(${NUMBER})\s*$`);

/**
 * Coordinates typed or pasted as "latitude, longitude" ("44.8125, 20.4612", as map apps copy
 * them, or with decimal commas "44,8125 20,4612"). Null when the text isn't a pair in range.
 */
export function parseCoordinates(text: string): MapPin | null {
  const match = PAIR.exec(text);
  if (!match) return null;
  const latitude = Number(match[1]!.replace(',', '.'));
  const longitude = Number(match[2]!.replace(',', '.'));
  if (Math.abs(latitude) > 90 || Math.abs(longitude) > 180) return null;
  return { latitude, longitude };
}

/** "44.81250, 20.46120": five decimals, about a metre. */
export const formatCoordinates = (pin: MapPin): string =>
  `${pin.latitude.toFixed(5)}, ${pin.longitude.toFixed(5)}`;

/** Where the phone app sends a runner without its own map app: Google Maps at the pin. */
export const mapsHref = (pin: MapPin): string =>
  `https://www.google.com/maps/search/?api=1&query=${pin.latitude},${pin.longitude}`;
